<template>
    <div class="tablesWrap" id="tablesWrap">
        <div class="tableContent" v-for="(item,index) in tableData">
            <!-- 决赛 只有一条数据 -->
            <div class="ranking_match_wrap" v-if="item.template === 'team_point_ranking_match'">
                <p class="fourthTit">{{item.content.name}}</p>
                <div class="list clearfix" v-for="(elem,index) in item.content.data">
                    <span class="date">{{elem.finalIneedTime.finalTime_md_hm}}</span>
                    <p class="teamA clearfix"><span class="teamA_name">{{elem.team_A_name}}</span><img
                        :src="getImgSrc(elem.team_A_logo)" class="teamA_logo" v-team-logo></p>
                    <p class="score">
                        <span
                            v-if="elem.status=='Cancelled'||elem.status=='Postponed'||elem.status=='Suspended'||item.status=='Uncertain'">--</span>
                        <span v-if="elem.status=='Fixture'||elem.status=='Playing'">VS</span>
                        <span v-if="elem.status=='Played'||elem.status=='Playing'"
                              :class="{'colorGreen':elem.status=='Playing'}">{{elem.fs_A}} : {{elem.fs_B}}</span>
                    </p>
                    <p class="teamB clearfix"><span class="teamB_name">{{elem.team_B_name}}</span><img
                        :src="getImgSrc(elem.team_B_logo)" class="teamB_logo" v-team-logo></p>
                </div>
            </div>
             <!--半决赛 total+2条数据-->
            <div class="ranking_aggregate_wrap" v-if="item.template === 'team_point_ranking_aggregate'">
                <p class="fourthTit">{{item.content.name}}</p>
                <div class="aggregate_wrap" v-for="(aggregate,num) in item.content.data">
                    <div class="list bgGray1 clearfix">
                        <span class="date padLTotal">Total</span>
                        <p class="teamA clearfix"><span class="teamA_name">{{aggregate.total.team_A_name}}</span><img
                            :data-src="getImgSrc(aggregate.total.team_A_logo)" v-team-logo
                            class="teamA_logo teamCompete_icon"></p>
                        <p class="score">
                            <!-- <span>VS</span> -->
                            <span>{{aggregate.total.fs_A}} : {{aggregate.total.fs_B}}</span>
                        </p>
                        <p class="teamB clearfix"><span class="teamB_name">{{aggregate.total.team_B_name}}</span><img
                            :data-src="getImgSrc(aggregate.total.team_B_logo)" v-team-logo
                            class="teamB_logo teamCompete_icon"></p>
                    </div>
                    <div class="list bgGray2 clearfix">
                        <span class="date">{{aggregate.match1.finalIneedTime.finalTime_md_hm}}</span>
                        <p class="teamA clearfix"><span class="teamA_name">{{aggregate.match1.team_A_name}}</span><img
                            :data-src="getImgSrc(aggregate.match1.team_A_logo)" v-team-logo
                            class="teamA_logo teamCompete_icon"></p>
                        <p class="score">
                            <span
                                v-if="aggregate.match1.status=='Cancelled'||aggregate.match1.status=='Postponed'||aggregate.match1.status=='Suspended'||aggregate.match1.status=='Uncertain'">--</span>
                            <span
                                v-if="aggregate.match1.status=='Fixture'||aggregate.match1.status=='Playing'">VS</span>
                            <span v-if="aggregate.match1.status=='Played'||aggregate.match1.status=='Playing'"
                                  :class="{'colorGreen':aggregate.match1.status=='Playing'}">{{aggregate.match1.fs_A}} : {{aggregate.match1.fs_B}}</span>
                        </p>
                        <p class="teamB clearfix"><span class="teamB_name">{{aggregate.match1.team_B_name}}</span><img
                            :data-src="getImgSrc(aggregate.match1.team_B_logo)" v-team-logo
                            class="teamB_logo teamCompete_icon"></p>
                    </div>
                    <div class="list bgGray2 clearfix">
            <span class="date">
            {{aggregate.match2.finalIneedTime.finalTime_md_hm}}</span>
                        <p class="teamA clearfix"><span class="teamA_name">{{aggregate.match2.team_A_name}}</span><img
                            :data-src="getImgSrc(aggregate.match2.team_A_logo)" v-team-logo
                            class="teamA_logo teamCompete_icon"></p>
                        <p class="score">
                            <span
                                v-if="aggregate.match2.status=='Cancelled'||aggregate.match2.status=='Postponed'||aggregate.match2.status=='Suspended'||aggregate.match2.status=='Uncertain'">--</span>
                            <span
                                v-if="aggregate.match2.status=='Fixture'||aggregate.match2.status=='Playing'">VS</span>
                            <span v-if="aggregate.match2.status=='Played'||aggregate.match2.status=='Playing'"
                                  :class="{'colorGreen':aggregate.match2.status=='Playing'}">{{aggregate.match2.fs_A}} : {{aggregate.match2.fs_B}}</span>
                        </p>
                        <p class="teamB clearfix"><span class="teamB_name">{{aggregate.match2.team_B_name}}</span><img
                            :data-src="getImgSrc(aggregate.match2.team_B_logo)" v-team-logo
                            class="teamB_logo teamCompete_icon"></p>
                    </div>
                </div>
            </div>
            <!-- 小组赛 -->
            <div class="ranking_group_wrap" v-if="item.template === 'team_point_ranking_group'">
                <p class="fourthTit bgGray1">{{item.content.name}}</p>
                <div class="groupWrap" v-for="(group,groupIndex) in item.content.data">
                    <p class="fourthTit">{{group.name}}</p>
                    <div class="teamWrap">
                        <p class="teamHeader">
                            <span class="teamHeader0"></span>
                            <span class="teamHeader1">{{group.header[0]}}</span>
                            <span class="teamHeader2">{{group.header[1]}}</span>
                            <span class="teamHeader3">{{group.header[2]}}</span>
                            <span class="teamHeader4">{{group.header[3]}}</span>
                            <span class="teamHeader5">{{group.header[4]}}</span>
                            <span class="teamHeader6">{{group.header[5]}}</span>
                            <span class="teamHeader7">{{group.header[6]}}</span>
                        </p>
                        <!-- {{group.top}}-{{group.data.length}}-{{group.end}} -->
                        <p class="teambodylist"
                           :class="{'topGreen':(groupListIndex<group.top),'endGray':(groupListIndex>=(group.data.length-group.end))}"
                           v-for="(grouplist,groupListIndex) in group.data">
                            <span class="teamHeader0">{{groupListIndex+1}}</span>
                            <span class="teamHeader1 clearfix"><img :data-src="getImgSrc(grouplist.team_logo)"
                                                                    v-team-logo class="team_icon teamCompete_icon"><b>{{grouplist.team_name}}</b></span>
                            <span class="teamHeader2">{{grouplist.matches_total}}</span>
                            <span class="teamHeader3">{{grouplist.matches_won}}</span>
                            <span class="teamHeader4">{{grouplist.matches_draw}}</span>
                            <span class="teamHeader5">{{grouplist.matches_lost}}</span>
                            <span class="teamHeader6">{{grouplist.goals_pro}}/{{grouplist.goals_against}}</span>
                            <span class="teamHeader7">{{grouplist.points}}</span>
                        </p>
                    </div>
                </div>
            </div>
             <!--联赛-->
            <div class="League_match_wrap" v-if="item.template === 'team_point_ranking_regular'">
                <p class="fourthTit" v-if="item.content.name">{{item.content.name}}</p>
                <div class="teamWrap">
                    <p class="teamHeader">
                        <span class="teamHeader0"></span>
                        <span class="teamHeader1">{{item.content.header[0]}}</span>
                        <span class="teamHeader2">{{item.content.header[1]}}</span>
                        <span class="teamHeader3">{{item.content.header[2]}}</span>
                        <span class="teamHeader4">{{item.content.header[3]}}</span>
                        <span class="teamHeader5">{{item.content.header[4]}}</span>
                        <span class="teamHeader6">{{item.content.header[5]}}</span>
                        <span class="teamHeader7">{{item.content.header[6]}}</span>
                    </p>
                    <!-- {{item.content.top}}-{{item.content.data.length}}-{{item.content.end}} -->
                    <p class="teambodylist"
                       :class="{'topGreen':(index<item.content.top),'endGray':(index>=(item.content.data.length-item.content.end))}"
                       v-for="(regular,index) in item.content.data">
                        <span class="teamHeader0">{{index+1}}</span>
                        <span class="teamHeader1 clearfix"><img :data-src="getImgSrc(regular.team_logo)"
                                                                class="team_icon teamCompete_icon" v-team-logo><b>{{regular.team_name}}</b></span>
                        <span class="teamHeader2">{{regular.matches_total}}</span>
                        <span class="teamHeader3">{{regular.matches_won}}</span>
                        <span class="teamHeader4">{{regular.matches_draw}}</span>
                        <span class="teamHeader5">{{regular.matches_lost}}</span>
                        <span class="teamHeader6">{{regular.goals_pro}}/{{regular.goals_against}}</span>
                        <span class="teamHeader7">{{regular.points}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        data: function () {
            return {};
        },
        created: function () {
        },
        methods: {},
        props: ['tableData', 'noDataMode'],
    };
</script>
<style lang="less">
    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .clearfix {
        *zoom: 1;
    }

    .clear {
        clear: both;
    }

    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    .groupWrap {
        font-size: .68rem;
    }

    .tablesWrap {
        height: auto;
        overflow: hidden;
    }

    .tablesWrap .tableTit {
        height: 1rem;
        background: #404c57;
        color: #fff;
        line-height: 1rem;
        font-size: 1rem;
    }

    .tablesWrap .tableTit span {
        display: inline-block;
        font-size: 1rem;
    }

    .tablesWrap .first {
        width: 1rem;
    }

    .tablesWrap .second {
        width: 1rem;
        text-align: center;
    }

    .tablesWrap .third {
        width: 1rem;
    }

    .tablesWrap .tableContent {
        background: #333d46;
    }

    .tablesWrap .leftArrow {
        width: 1rem;
        margin-left: 1rem;
        margin-right: 1rem;
        position: relative;
        top: 1rem;
    }

    .tablesWrap .rightArrow {
        width: 1rem;
        margin-left: 1rem;
        position: relative;
        top: 1rem;
    }

    .tablesWrap .list {
        font-size: .68rem;
        height: 2.8rem;
        line-height: 1rem;
        overflow: hidden;
        color: #fff;
        border-bottom: 1px solid #2b353d;
    }

    .tablesWrap .date {
        width: 5.5rem;
        color: #929cad;
        text-align: center;
    }

    .tablesWrap .teamA_name, .tablesWrap .teamB_name {
        width: 5.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        text-align: right;
    }

    .tablesWrap .score {
        width: 2rem;
        text-align: center;
    }

    .tablesWrap .teamA_logo, .tablesWrap .teamB_logo {
        width: 1.2rem;
        height: auto;
        margin: .8rem .5rem;
        vertical-align: middle;
        overflow: hidden;
        float: left;
    }

    .tablesWrap .teamB_name {
        float: right !important;
        text-align: left !important;
    }

    .tablesWrap .date, .tablesWrap .teamA, .tablesWrap .score, .tablesWrap .teamB {
        float: left;
        height: 2.8rem;
        line-height: 2.8rem;
    }

    .tablesWrap .list span {
        display: inline-block;
    }

    .tablesWrap .fourthTit {
        padding-left: .68rem;
        color: #fff;
        font-size: .68rem;
        height: 1.7rem;
        line-height: 1.7rem;
        background: #262e35;
    }

    .tablesWrap .bgGray1 { //1最白
        background: #404c57 !important;
    }

    .tablesWrap .bgGray2 { //2次白
        background: #333d46 !important;
    }

    .tablesWrap .bgGray3 { //3黑灰
        background: #262e35;
    }

    .tablesWrap .teamHeader {
        height: 1.7rem;
        line-height: 1.7rem;
        background: #404c57;
    }

    .tablesWrap .teamHeader0 {
        width: 1.2rem;
    }

    .tablesWrap .teamHeader1 {
        width: 8.3rem;
        text-align: left !important;
    }

    .tablesWrap .teamHeader2, .tablesWrap .teamHeader3, .tablesWrap .teamHeader4, .tablesWrap .teamHeader5, .tablesWrap .teamHeader7 {
        width: 1.7rem;
        /*margin-right: .4rem;*/
    }

    .tablesWrap .teamHeader6 {
        width: 2.5rem;
    }

    .tablesWrap .teamHeader span, .tablesWrap .teambodylist span {
        display: inline-block;
        text-align: center;
    }

    .tablesWrap .ranking_group_wrap {
        color: #fff;
    }

    .tablesWrap .team_icon {
        width: 1.5rem;
        height: auto;
        vertical-align: middle;
        margin-right: .6rem;
        margin-top: .6rem;
        float: left;
    }

    .tablesWrap .teambodylist {
        height: 2.7rem;
        line-height: 2.7rem;
        overflow: hidden;
        background: #333d46;
        border-bottom: 1px solid #2b353d;
    }

    .tablesWrap .teamHeader1 b {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 6rem;
        display: inline-block;
        line-height: 2.7rem;
        font-weight: normal;
    }

    .tablesWrap .teambodylist span {
        line-height: 2.7rem;
        height: 2.7rem;
        overflow: hidden;
    }

    .tablesWrap .topGreen {
        background: #16b13a !important;
        border-bottom: 1px solid #1f8538;
    }

    .tablesWrap .endGray {
        background: #404c57 !important;
    }

    .tablesWrap .League_match_wrap {
        color: #fff;
        font-size: .68rem;
    }

    .tablesWrap .padLTotal {
        text-indent: 0.68rem;
        text-align: left;
    }

    .colorGreen {
        color: #16ac3a !important;
    }
</style>



// WEBPACK FOOTER //
// table.vue?661676dd